import { useEffect, useRef } from 'react';

import { usePanorama } from '@wix/yoshi-flow-editor';

export const usePanoramaTransaction = (name: string, isLoaded: boolean) => {
  const panorama = usePanorama();
  const transaction = useRef<ReturnType<typeof panorama.transaction> | null>(
    null,
  );

  useEffect(() => {
    if (!isLoaded && !transaction.current) {
      transaction.current = panorama.transaction(name);
      transaction.current.start();
    } else if (isLoaded && transaction.current) {
      transaction.current.finish();
      transaction.current = null;
    }
    return () => {
      transaction.current = null;
    };
  }, [isLoaded, name, panorama]);
};
